import { Text, Heading } from '@devfolioco/genesis';
import React from 'react';
import styled from 'styled-components';

import { BASE_URL } from '@constants/environment';

const ProjectItem = styled.div`
  margin-bottom: 36px;

  &:last-child {
    margin-bottom: 0px;
  }
`;

const Project = ({ name = '', slug = '', tagline = '', hashtags = [] }) => (
  <ProjectItem>
    <a href={`${BASE_URL}projects/${slug}`} target="_blank" rel="noopener noreferrer">
      <Heading appearance="H2" color="blue-4">
        {name}
      </Heading>
    </a>

    <Text style={{ margin: '8px 0', display: 'block' }}>{tagline}</Text>
    <Text color="grey-7">{hashtags?.map(tag => tag.name)?.join(', ') || ''}</Text>
  </ProjectItem>
);

export default React.memo(Project);
